(ns livefeed.footer.reaction-buttons
  (:require [reagent.core :as reagent :refer [atom with-let]]
            [livefeed.feed-reactions :as feed-reactions]
            [livefeed.state :as state]
            [livefeed.tunnus :as tunnus]
            [livefeed.websocket :as websocket]))

(def disabled? (atom false))

(defn reaction-button [reaction]
  (with-let [clicked? (atom false)
             on-click (fn [e]
                        (if @state/logged-in
                          (let [button-left (.-left (.getBoundingClientRect (.-target e)))
                                emoji-pos (- js/window.innerWidth button-left 20)]
                            (websocket/send-feed-reaction (:id reaction))
                            (feed-reactions/add-reaction-at! (:id reaction) emoji-pos)
                            (reset! clicked? true)
                            (reset! disabled? true)
                            (js/setTimeout #(reset! clicked? false) 150)
                            (js/setTimeout #(reset! disabled? false) 500))
                          (tunnus/login!)))]
    [:button.yle-livefeed__input__button
     {:on-click on-click
      :class    (when @clicked? :yle-livefeed__input__button--clicked)
      :disabled @disabled?
      :aria-label (:name reaction)}
     [:img.yle-livefeed__input__button__image
      {:src       (:src reaction)
       :draggable false}]]))

(defn component [reactions]
  (into [:<>]
        (for [id reactions
              :let [reaction (get @state/emojis id)]]
          ^{:key id}
          [reaction-button reaction])))
